import { motion } from "framer-motion";
import { Check } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export function OpportunityExpansion({ t, items, selected, toggle, onContinue, sending }) {
  return (
    <motion.div
      data-testid="opportunity-expansion"
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.7, ease: EASE }}
      className="relative z-10 w-full max-w-2xl mx-auto text-center"
    >
      <h3 className="font-display text-2xl md:text-3xl tracking-tight">{t.opportunity.title}</h3>
      <p className="mt-3 text-sm md:text-base text-bh-soft">{t.opportunity.sub}</p>

      <div className="mt-10 space-y-3 text-left">
        {items.map((it, i) => {
          const on = selected.includes(it.key);
          return (
            <motion.button
              key={it.key}
              data-testid={`opportunity-item-${i}`}
              onClick={() => toggle(it.key)}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: EASE, delay: 0.1 + i * 0.08 }}
              className={`group flex w-full items-start gap-4 border-b py-4 text-left transition-colors ${on ? "border-bh-ink" : "border-bh-line hover:border-bh-c2"}`}
            >
              <span className={`mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border transition-colors ${on ? "border-bh-ink bg-bh-ink text-white" : "border-bh-c2 text-transparent"}`}>
                <Check size={11} strokeWidth={2.5} />
              </span>
              <span>
                <span className="font-display text-lg tracking-tight text-bh-ink">{it.title}</span>
                <span className="mt-1 block text-sm text-bh-soft">{it.body}</span>
              </span>
            </motion.button>
          );
        })}
      </div>

      <div className="mt-10 flex items-center justify-center gap-8">
        <button
          data-testid="opportunity-continue"
          onClick={onContinue}
          disabled={sending}
          className="group inline-flex items-center gap-3 text-lg disabled:opacity-40"
        >
          <span className="relative">
            {sending ? t.contact.sending : selected.length ? t.opportunity.continueSelected : t.opportunity.continueSkip}
            <span className="absolute left-0 -bottom-1 h-px w-full bg-bh-ink origin-left scale-x-100 group-hover:scale-x-0 transition-transform duration-500" />
            <span className="absolute left-0 -bottom-1 h-px w-full bg-bh-ink origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 delay-100" />
          </span>
          {!sending && <span className="transition-transform duration-500 group-hover:translate-x-2">→</span>}
        </button>
      </div>
    </motion.div>
  );
}
